import { MoveType } from "@chesshotel/types";
export function evaluationToExpectedPoints(evaluation) {
    const k = 0.5;
    return 1 / (1 + Math.exp(-k * evaluation));
}
export function gradeFromExpectedLoss(loss) {
    const x = Math.min(1, loss);
    if (x <= 0.005)
        return 1.0;
    if (x <= 0.015)
        return 0.9;
    if (x <= 0.03)
        return 0.8;
    if (x <= 0.06)
        return 0.65;
    if (x <= 0.1)
        return 0.45;
    if (x <= 0.2)
        return 0.25;
    if (x <= 0.3)
        return 0.15;
    return 0.05;
}
export function getExpectedPointsLossForMove(gameReview, idx, isWhite) {
    const prev = gameReview[idx - 1];
    const curr = gameReview[idx];
    if (!prev || !curr)
        return 0;
    if (prev.score == null || curr.score == null)
        return 0;
    const whiteBestEP = evaluationToExpectedPoints(prev.score);
    const whitePlayedEP = evaluationToExpectedPoints(curr.score);
    let bestEP;
    let playedEP;
    if (isWhite) {
        bestEP = whiteBestEP;
        playedEP = whitePlayedEP;
    }
    else {
        bestEP = 1 - whiteBestEP;
        playedEP = 1 - whitePlayedEP;
    }
    const loss = bestEP - playedEP;
    return Math.max(0, Math.min(1, loss));
}
export function calculateAccuracy(gameReview, isWhite) {
    let sumGrades = 0;
    let moveCount = 0;
    for (let idx = 1; idx < gameReview.length; idx++) {
        const moveByWhite = idx % 2 === 1;
        if (moveByWhite !== isWhite)
            continue;
        const pos = gameReview[idx];
        if (pos.moveType === MoveType.BOOK) {
            sumGrades += 1.0;
            moveCount++;
            continue;
        }
        const prev = gameReview[idx - 1];
        if (prev?.moveType === MoveType.BOOK) {
            sumGrades += 1.0;
            moveCount++;
            continue;
        }
        const loss = getExpectedPointsLossForMove(gameReview, idx, isWhite);
        const grade = gradeFromExpectedLoss(loss);
        sumGrades += grade;
        moveCount++;
    }
    if (moveCount === 0)
        return 0;
    const avgGrade = sumGrades / moveCount;
    const a = 1.6;
    const adjusted = Math.pow(avgGrade, a) * 100;
    return Math.round(adjusted * 10) / 10;
}
//# sourceMappingURL=statistics.js.map